import React from 'react'
import { render } from 'react-dom'
import { Provider as ReduxStoreProvider } from 'react-redux'
import { createStore } from 'redux'
import { App } from './App'
import { AppProvider } from './AppProvider'
import * as serviceWorker from './serviceWorker'
import './base.css'
import { rootReducer } from '@landscape/ui-redux'
import { DashboardReactContextProvider } from '@landscape/ui-lib'
import { RecoilRoot } from 'recoil'
import ReactDOM from 'react-dom/client'

const reduxStore = createStore(rootReducer)

const Index = () => {
  return (
    <AppProvider>
      <ReduxStoreProvider store={reduxStore}>
        <RecoilRoot>
          <DashboardReactContextProvider>
            <App />
          </DashboardReactContextProvider>
        </RecoilRoot>
      </ReduxStoreProvider>
    </AppProvider>
  )
}

const rootElement = document.getElementById('root')
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement)
  console.log(React.version)

  root.render(<Index />)
} else {
  console.error('Failed to find the root element')
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
// registerServiceWorker()
